import { Component, Injectable, PLATFORM_ID, Inject, ElementRef, Renderer2, OnInit } from '@angular/core';
import { isPlatformBrowser,isPlatformServer } from '@angular/common';
import { MetaService } from "./_services/meta.service";
import { DOCUMENT } from '@angular/common';
import { HttpService } from "./modules/http-with-injector/http.service";
import { isJson } from "./globals/_classes/functions";
import { ActivatedRoute, NavigationEnd, NavigationStart, Router } from '@angular/router';
import { filter, map, mergeMap } from 'rxjs/operators';
import { Helpers } from './helpers';
import { setOptions } from '@mobiscroll/angular';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit{
  title = 'rentmyStore';
  trackingCode = "";
  // dynamicTitle: string;
  constructor(@Inject(DOCUMENT) private document: any
  ,private http:HttpService
  ,@Inject(PLATFORM_ID) private platform: Object
  ,private metaService:MetaService
  ,@Inject(PLATFORM_ID) private platformId: Object
  ,private readonly renderer: Renderer2
  ,private readonly el: ElementRef
  ,private router:Router
  ,private activeRoute: ActivatedRoute){
    if(isPlatformBrowser(this.platformId)){
      // let storeId = sessionStorage.getItem('online_store') ? JSON.parse(sessionStorage.getItem('online_store'))?.store?.id : '';
      // set mobiscroll options
      setOptions({
        theme: 'auto',
        themeVariant: 'light'
      });
    }
  }

  ngOnInit(){
    this.loadHomeResolverContents();

    if(isPlatformBrowser(this.platformId)){
      this.loadInitialWork();
    }
    // if(isPlatformServer(this.platformId)){
    //   console.log("in server")
    // }
  }
  loadHomeResolverContents() {
    let url = this.document.location.href
    let urlParts = /^(?:\w+\:\/\/)?([^\/]+)(.*)$/.exec(url);
    let domain = urlParts[1]
    //console.log("host: " + urlParts[1],urlParts[2]);
    const subDomaPos = domain.search("leaperdev.rocks");
    let subDomain = '';
    if (subDomaPos !== -1) {
      subDomain = domain.split(".")[0]
    } else {
      subDomain = domain;
    }
    // if (subDomain === "beach-day-llc") {
    //   this._script.loadScript('body', 'assets/js/admin/beach_day_tawk.js');
    // }

    let url_key;
    //if (isPlatformBrowser(this.platform)) {
    const path = this.document.location.href;
    console.log(path)
    if (path.includes("video-wall")) {
      url_key = 'guest-token';
    }
    else {
      url_key = 'get-settings';
    }
    return this.http
      .get(
        url_key + `?store_name=${subDomain.includes("localhost") ? "teststore17" : subDomain
        }`
      )
      .toPromise()
      .then(res => {

        if (res.status === "OK") {
          let result = res.result;
          if (
            result.location && result.location.id && result.store.token
          ) {
            if (isPlatformBrowser(this.platform)) {
              if (result.store.id == 1299) {
                result.store.layout.layout_id = 5; //will be removed
              }

              let currentLoc = JSON.parse(localStorage.getItem('current_location'));
              // sessionStorage.setItem("online_store", JSON.stringify(res.result));
              if (!currentLoc || !Array.isArray(result.locations) ||
                !result.locations.find(loc=> loc.id == currentLoc.id)) {
                // console.log('1 currentLoc: ', currentLoc);
                // console.log('1 result.locations: ', result.locations);
                // console.log('1 find: ', result.locations.find(loc => loc.id == currentLoc.id));
                localStorage.setItem("current_location", JSON.stringify(result.location));
                sessionStorage.setItem("online_store", JSON.stringify(result));
              } else {
                result['location'] = currentLoc;
                // console.log('2 result: ', result);
                sessionStorage.setItem("online_store", JSON.stringify(result));
              }

              if (result.store.layout.layout_id == 5) {
                // load styles for viva theme
                Helpers.loadStyles("head", "assets/css/home/css/viva-style.css");
              }

            }
            this.document.online_store = JSON.stringify(res.result);
            this.http.get("contents").toPromise()
              .then(res => {
                // console.log(res)
                const content = {};
                const data = res.result.data.filter(f => {
                  return f["config"].status === 1;
                });

                for (const c of data) {
                  const tag = this.formatTag(c.config.tag);
                  content[tag] = isJson(c.contents)
                    ? JSON.parse(c.contents)
                    : c.contents;
                }
                if (isPlatformBrowser) {
                  localStorage.setItem("contents", JSON.stringify(content));
                }
                this.document.contents = JSON.stringify(content);
                this.metaService.addTags(content['site_specific'].meta_contents)
              })
            return res.result;
          }
        }
        return null;
      })
      .catch(err => {
        console.log(err);
        return null;
      });
  }
  loadInitialWork(){
    // let storeName = '';
    // let appTitleName = "";
    // let default_title_url = "";
    this.router.events.subscribe(route => {
      if (route instanceof NavigationStart) {
        Helpers.setLoading(true);
        // storeName = getStoreName();
        // if(route.url.includes("partner"))
        // {
        //   appTitleName="RentMy – The complete rental management solution" + ":: "
        // }
        // else if(route.url.includes("auth")){
        //   appTitleName="RentMy" + ":: "
        // }
        // else{
        //   appTitleName=storeName + ":: ";
        // }
        // default_title_url = route.url.split("/").reverse()[0];
        // default_title_url=default_title_url.includes('?') ? default_title_url.split('?')[0]:default_title_url;
      }
      window.scrollTo(0, 0);
    });

    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd),
      map(() => this.activeRoute),
      map(route => {
        while (route.firstChild) route = route.firstChild;
        return route;
      }),
      filter(route => route.outlet === "primary"),
      mergeMap(route => route.data)
    ).subscribe(event => {
        Helpers.setLoading(false);
        // if (event.title) {
        //   this.dynamicTitle = appTitleName + "" + event["title"];
        // } else {
        //   this.dynamicTitle = appTitleName + "" + default_title_url;
        // }
        // this.titleS.setTitle(this.dynamicTitle);
      });

    window.scrollTo(0, 0);
  }

  formatTag(text: String) {
    return text.replace(/(\-[a-z])/g, function($1) {
      return $1.toUpperCase().replace("-", "");
    });
  }
}
